'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGTextBase = function SVGTextBase(props) {
  return _react2.default.createElement('text', _extends({ x: '50', width: '100%' }, props));
};

exports.default = (0, _styledComponents2.default)(SVGTextBase).withConfig({
  displayName: 'SVGTextStyle'
})(['alignment-baseline:middle;dominant-baseline:middle;text-transform:uppercase;user-select:none;']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.1456/js/UIAvatarDisplay/baseStyledComponents/SVGTextStyle.js
// module id = 193
// module chunks = 171